import { BannerType } from '@fluidx/office-fluid-types';
import { NamespaceLoggerAdapter, sendErrorEvent, sendTelemetryEvent } from '@fluidx/telemetry';
import { getMeetingInformation, isSeriesTemplateMeetingNote, isSeriesOccurrenceMeetingNote } from '@fluidx/utilities';
import { EventEmitter } from 'events';
import { getStringTableIfNeeded } from '../../utilities/localizationUtilities.dynamic';
import { GenericEvent } from '../../telemetry/GenericEvent';
import { ErrorEvent } from '../../telemetry/ErrorEvent';
export class MeetingNotesBannerProvider extends EventEmitter {
    get MessageBannerProvider() {
        return this;
    }
    startMeetingNotesProvider() {
        const meetingsProvider = this.component;
        // Check if meeting information is available
        if (!meetingsProvider.ComponentMeetingInformationProvider) {
            this.logger && sendTelemetryEvent(this.logger, {
                eventName: GenericEvent.MeetingInformationProviderNotFound
            });
            return;
        }
        Promise.all([
            getMeetingInformation(meetingsProvider),
            getStringTableIfNeeded(this.stringTableOrLocale)
        ]).then(([meetingInfo, stringTable])=>{
            if (!meetingInfo) {
                this.logger && sendErrorEvent(this.logger, {
                    eventName: ErrorEvent.MeetingInformationNotFound
                });
                return;
            }
            // Check if the meetings notes are for an occurrence of a meeting series
            if (isSeriesOccurrenceMeetingNote(meetingInfo)) {
                this.emit('CreateBanner', {
                    bannerId: 'MeetingOccurrenceBanner',
                    bannerType: BannerType.info,
                    bannerStrings: {
                        bannerMessage: stringTable.meetingNotesOccurrenceBannerMessage
                    },
                    isDismissible: false
                });
            } else if (isSeriesTemplateMeetingNote(meetingInfo)) {
                this.emit('CreateBanner', {
                    bannerId: 'MeetingSeriesBanner',
                    bannerType: BannerType.info,
                    bannerStrings: {
                        bannerMessage: stringTable.meetingNotesSeriesBannerMessage
                    },
                    isDismissible: false
                });
            }
        }).catch((error)=>{
            this.logger && sendErrorEvent(this.logger, {
                eventName: ErrorEvent.MeetingNotesBannerFailed
            }, error);
        });
    }
    /** Disposes the meeting notes banner provider */ dispose() {
        this.removeAllListeners();
    }
    constructor(component, stringTableOrLocale, /** The logger to be used for telemetry */ logger){
        super();
        this.component = component;
        this.stringTableOrLocale = stringTableOrLocale;
        this.logger = logger && new NamespaceLoggerAdapter('MeetingNotes', logger);
        this.startMeetingNotesProvider();
    }
}
